import React, { useState } from "react";

import { Button, Divider } from "@mui/material";
import "./DemoPage.css";
// import { demoVideoJSON } from "./demoVideos";
import VideoModal from "../../LandingPage/VideoPlayer";
import { vi } from "date-fns/locale";

// import FeatureCarousel from "./FeatureCarousel";

const buttonStyle = {
  zIndex: 1000,
  borderRadius: "1.5rem",
  color: "#fff",
  fontWeight: "bold",
  textTransform: "none",
  fontSize: "18px",
  padding: "5px 18px 5px 18px;" /*Top padding 0 bcs font has gap at the top*/,
  background: "linear-gradient(135deg,#C69EEE, #8A14FE, #2B094C)",
};

function DemoPage({ videoData }) {
  const [open, setOpen] = useState(false);
  const [link, setLink] = useState("");
  const [title, setTitle] = useState("");
  const handleOpen = (link, title) => {
    console.log(link);

    setLink(link);
    setTitle(title);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleRectangleClick = (videoUrl) => {
    console.log(videoUrl);
  };

  return (
    <div className="lp-container">
      {videoData.map((video) => (
        <div key={video.id} className="hero-section">
          <div className="hero">
            <h4>{video.title}</h4>

            <div className="title">
              {/* <h1 className="digital">Digital</h1>
              <h1 className="transformation">Transformation</h1> */}
            </div>
            <p>{video.description}</p>
          </div>
          <div className="hero-img">
            {" "}
            <Button
              sx={{ borderRadius: "1rem", ...buttonStyle }}
              variant="contained"
              onClick={() => handleOpen(video.link, video.title)}
            >
              Watch Demo
            </Button>
          </div>
        </div>
      ))}
      <VideoModal
        open={open}
        handleClose={handleClose}
        link={link}
        videoTitle={title}
      />
    </div>
  );
}

export default DemoPage;
